//import 'babel-polyfill';
import "core-js/stable";
import * as Vue from 'vue'
//import Vue from 'vue';
import { h } from 'vue';
import App from './App.vue';
import { store } from './store';

import ElementPlus from 'element-plus/es';
import 'element-plus/dist/index.css';

const config = window.conf;

const app = Vue.createApp({
    components: { App }, 
    render() {
        return h(App, {
            conf: config
        });
    }
});
app.use(ElementPlus);
app.use(store);
app.mount("#supervisedentities-app");
